import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BlobStorageService {

  constructor() { }

  downloadFile(base64: string, fileName: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  }

  async readFileAsBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = e => {
        const result = (e.target as FileReader).result;
        if (result) {
          // Extracting base64 content by removing the prefix
          const base64Content = result.toString().split(',')[1];
          return resolve(base64Content);
        } else {
          return reject(null);
        }
      };

      reader.onerror = e => {
        return reject(null);
      };

      if (!file) {
        return reject(null);
      }

      reader.readAsDataURL(file);
    });
  }

  base64ToFile(base64Content: string, fileName: string, fileType: string): File | null {
    const binaryData = atob(base64Content);
    const uint8Array = new Uint8Array(binaryData.length);

    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: fileType });

    try {
      return new File([blob], fileName, { type: fileType });
    } catch (error) {
      const blobWithProps = Object.assign(blob, { name: fileName, lastModified: Date.now() });
      return blobWithProps as File;
    }
  }

  createImagePreviewBlobUrl(base64Image: string) {
    try {
      const byteCharacters = atob(base64Image.split(',')[1]);
      const byteNumbers = new Uint8Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const imageType = this.getImageType(base64Image) || 'image/png';
      const blob = new Blob([byteNumbers], { type: imageType });
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Failed to create URL:', error);
      return null; // Or handle the error as appropriate
    }
  }

  getImageType(base64Image: string): string | null {
    const matches = base64Image.match(/^data:(.*?);base64,/);
    return matches ? matches[1] : null; // Returns the MIME type or null if not found
  }
}
